"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNTimeoutButton = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _clsx = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    button: {
      height: 58,
      flex: 1,
      borderRadius: 6,
      zIndex: 2,
      overflow: 'hidden',
      display: 'flex',
      backgroundColor: theme.custom.colors.greyMedium
    },
    overlay: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      background: theme.custom.colors.overlayGrey,
      opacity: 0.15,
      left: 0,
      zIndex: 1
    },
    label: theme.typography.h5,
    text: {
      zIndex: 3,
      position: 'absolute'
    }
  };
});

/**
 * REQUIRED
 * @param {Ref} ref set the ref so you can pause and unpause the timer
 * @param {String} text the button text
 * @param {Function} onClick called when button is clicked or the button expires
 * OPTIONAL
 * @param {Boolean} fullWidth default true - set the button to be full width
 * @param {String} variant default 'contained' - Options are 'contained', 'text', 'outlined'
 * @param {String} color default 'primary' - Options are 'default', 'inherit', 'primary', 'secondary'
 * @param {Number} countdownTime default 1 - the time to expire in seconds
 * @param {String} countdownColor the rectangle color for the expiring time.
 */
var VNTimeoutButton = (0, _react.forwardRef)(function (props, ref) {
  var theme = (0, _styles.useTheme)();
  var classes = useStyles();
  var _useState = (0, _react.useState)(100),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var widthRef = (0, _react.useRef)(100);
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    paused = _useState4[0],
    setPaused = _useState4[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      isPaused: function isPaused(paused) {
        setPaused(paused);
      },
      resetTimer: function resetTimer() {
        widthRef.current = 100;
        setWidth(100);
      }
    };
  });
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      if (!paused) {
        widthRef.current = widthRef.current - 1;
        if (widthRef.current <= 0) {
          props.onClick();
          clearInterval(interval);
          widthRef.current = 0;
        }
        setWidth(widthRef.current);
      }
    }, props.countdownTime ? props.countdownTime * 10 : 10);
    return function () {
      return clearInterval(interval);
    };
  });
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    classes: {
      label: (0, _clsx.default)(props.label && props.label)
    },
    disabled: props.disabled ? props.disabled : false,
    onClick: props.onClick ? props.onClick : function () {},
    fullWidth: props.fullWidth ? props.fullWidth : true,
    variant: props.variant ? props.variant : 'contained',
    color: props.color ? props.color : 'secondary',
    className: classes.button,
    style: theme.custom[props.buttonVariant]
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.text
  }, props.text), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.overlay,
    style: {
      width: "".concat(width, "%")
    }
  }));
});
exports.VNTimeoutButton = VNTimeoutButton;